import { render, staticRenderFns } from "./FoodPage.vue?vue&type=template&id=5a08f54c"
import script from "./FoodPage.vue?vue&type=script&lang=js"
export * from "./FoodPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/food.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports